import { Component, OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';

@Component({
  selector: 'app-product-info',
  templateUrl: './product-info.component.html',
  styleUrls: ['./product-info.component.scss'],
})
export class ProductInfoComponent implements OnInit {
  characteristics: any;

  constructor(
    private navigationService: NavigationService,
    private headerService: HeaderService,
    public copyService: CopyService,
    public parametersService: ParametersService,
    private abreCuentasService: AbreCuentasService,
    private bitacoraService: BitacoraService,
  ) {
    this.headerService.show(false, false, true);
  }

  ngOnInit() {
    this.characteristics = this.parametersService.getSetting(OpEnum.HOUSING_CHARACTERISTICS);
    this.saveInBitacora();
  }

  saveInBitacora() {
    if (this.abreCuentasService.getPostlogin() &&
      this.abreCuentasService.getproductSelected().name === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      const bitacoraEvent = `is_client`;
      this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    }
  }

  next() {
    this.navigationService.nextStep();
  }

}
